"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.navigateWithReset = exports.pushRoute = exports.navigateWithClear = exports.goToRoute = exports.goBack = exports.navigationRef = void 0;
const async_storage_1 = __importDefault(require("@react-native-async-storage/async-storage"));
const native_1 = require("@react-navigation/native");
const react_native_1 = require("react-native");
/** @description This shouldn't be used directly. It will affect globally **/
exports.navigationRef = (0, native_1.createNavigationContainerRef)();
function goBack() {
    console.log('goBack', exports.navigationRef);
    exports.navigationRef.goBack();
}
exports.goBack = goBack;
const routeList = ["CAROUSAL_PAGE", "PHONE_NUMBER", "OTP_VERIFY", "BORROWER_LANDING_SCREEN", "EMAIL_VERIFY", "ENTER_EMAIL", "KYC_PAN_VERIFICATION", "PAN_CONFIRM_NAME"];
/** @description Navigate to an existing Micro-frontend Page initially created by routeMap **/
function goToRoute(name, params, shouldPush = false, extraProps) {
    return __awaiter(this, void 0, void 0, function* () {
        if (exports.navigationRef.isReady()) {
            console.log('goToRoute CURRENT ROUTE ID IS', extraProps, name);
            let newArchConfig = yield async_storage_1.default.getItem('show_new_arch');
            if (routeList.includes(name) &&
                (extraProps === null || extraProps === void 0 ? void 0 : extraProps.setRoutingSupport) && newArchConfig === 'true') {
                extraProps === null || extraProps === void 0 ? void 0 : extraProps.setRoutingSupport({
                    renderNewArch: true,
                    routeName: '',
                    params: {},
                });
                return;
            }
            try {
                console.log('In the navigation block');
                react_native_1.Keyboard.dismiss();
                !shouldPush
                    ? exports.navigationRef.navigate(name, params)
                    : pushRoute(name, params);
            }
            catch (e) {
                console.log('Error is navigation $$$$$$$', e);
            }
            // pushRoute(name, params);
        }
        else {
            console.log("Error is in navigation");
        }
    });
}
exports.goToRoute = goToRoute;
function navigateWithClear(name, params, shouldPush = false, extraProps) {
    return __awaiter(this, void 0, void 0, function* () {
        react_native_1.Keyboard.dismiss();
        if (exports.navigationRef.isReady()) {
            let newArchConfig = yield async_storage_1.default.getItem('show_new_arch');
            console.log("navigateWithClear CURRENT ROUTE ID IS", extraProps, name, routeList);
            if (routeList.includes(name) && (extraProps === null || extraProps === void 0 ? void 0 : extraProps.setRoutingSupport) && newArchConfig === 'true') {
                extraProps === null || extraProps === void 0 ? void 0 : extraProps.setRoutingSupport({
                    renderNewArch: true,
                    routeName: '',
                    params: {},
                });
                return;
            }
            try {
                console.log("In the navigation block");
                exports.navigationRef.dispatch(native_1.StackActions.replace(name, params));
            }
            catch (e) {
                console.log("Error is navigation $$$$$$$", e);
            }
            //pushRoute(name, params);
        }
        else {
            console.log("Error is in navigation");
        }
    });
}
exports.navigateWithClear = navigateWithClear;
/** @description create a new Micro-frontend page with new props.
 *  @function pushRoute use to create dynamic new route with new props
 *  @param args accepts  as routeId, props **/
function pushRoute(...args) {
    if (exports.navigationRef.isReady()) {
        try {
            exports.navigationRef.dispatch(
            // @ts-ignore
            native_1.StackActions.push(...args));
        }
        catch (e) {
            console.log(`*** error in navigation: ${e}`);
        }
    }
}
exports.pushRoute = pushRoute;
function navigateWithReset(name, params, extraProps) {
    return __awaiter(this, void 0, void 0, function* () {
        console.log("navigateWithReset CURRENT ROUTE ID IS", extraProps, name, routeList.includes(name));
        let newArchConfig = yield async_storage_1.default.getItem('show_new_arch');
        if (routeList.includes(name) && (extraProps === null || extraProps === void 0 ? void 0 : extraProps.setRoutingSupport) && newArchConfig === 'true') {
            console.log('resetting to new arch');
            extraProps === null || extraProps === void 0 ? void 0 : extraProps.setRoutingSupport({
                renderNewArch: true,
                routeName: '',
                params: {},
            });
            return;
        }
        exports.navigationRef.reset({
            index: 0,
            routes: [{ name: name, params: params }],
        });
    });
}
exports.navigateWithReset = navigateWithReset;
//# sourceMappingURL=root_navigation.js.map